import React, { forwardRef } from 'react';
import { DataTable as PrimeDataTable } from 'primereact/datatable';
import { LoadingRegion, TableSkeleton } from 'components/PortalLoading';

function getColumns(children) {
    return React.Children.toArray(children).flatMap((child) => {
        if (!React.isValidElement(child)) return [];
        if (child.type === React.Fragment) return getColumns(child.props.children);
        const { header, field, selectionMode, expander, hidden } = child.props;
        if (hidden) return [];
        const label = typeof header === 'string' ? header : field?.replace(/[_.]/g, ' ') || (selectionMode ? 'Select' : expander ? 'Details' : '');
        const kind = selectionMode ? 'selection' : /cover/i.test(label) ? 'cover' : /book|title/i.test(label) ? 'book' : /user|reader|name|ambassador|courier/i.test(label) ? 'person' : undefined;
        return [{ label, kind }];
    });
}

// Use the real column headers without invoking row actions with fabricated records.
export const DataTable = forwardRef(function PortalDataTable({ loading, loadingLabel = 'Loading records…', children, ...props }, ref) {
    const hasData = props.value?.length > 0;
    if (loading && !hasData) return <div className={props.className}>
        {props.header && <div className="portal-loading-table-header">{typeof props.header === 'function' ? props.header(props) : props.header}</div>}
        <TableSkeleton columns={getColumns(children)} rows={Math.min(props.rows || 5, 6)} label={loadingLabel} />
    </div>;
    return <>
        {loading && <div className="portal-loading-refresh"><LoadingRegion label="Updating records…" /></div>}
        <PrimeDataTable {...props} className={`akello-data-table ${props.className || ''}`} tableStyle={{ '--akello-table-min-width': `${getColumns(children).length * 8}rem`, ...props.tableStyle }} ref={ref} loading={false}>{children}</PrimeDataTable>
    </>;
});

export default DataTable;
